import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
	classRoomsAction,
	playersAction
} from '../../actions/contentActions'
import ClassRooms from '../content/ClassRooms'
import Players from '../content/Players'

class ClassRoomsContainer extends Component {
	/* toClassRoom = id => {
		let url = this.props.match.url

		this.props.history.push(`${url}/${id}`)
	}

	locationListener = () => {
		if (this.props.match.params.id) {
			let id = this.props.match.params.id

			this.toClassRoom(id)
		}
	}

	componentWillMount() {
		this.props.history.listen((obj, action) => {
			const classRoomId = this.props.match.params.id ?
				this.props.match.params.id : false

			if((action == "POP" && classRoomId)) {
				this.locationListener()
			}
		})
	} */

	state = {
		classRoomId: null
	}

	toClassRoom = id => {
		this.setState({ classRoomId: id })
	}

	componentWillMount() {
		this.setState({classRoomId: null})
	}

	render() {
		const classRoomId = this.state.classRoomId

		return (
			classRoomId ?
				<Players
					accountId={this.props.accountId}
					classRoomId={classRoomId}
					players={this.props.players}
					initPlayers={this.props.initPlayers}
					back={()=> this.toClassRoom(null)}
				/>
				:
				<ClassRooms
					accountId={this.props.accountId}
					classRooms={this.props.classRooms}
					initClassRooms={this.props.initClassRooms}
					pageChange={this.props.classRoomsPageChange}
					toClassRoom={this.toClassRoom}
				/>
		)
	}
}

ClassRoomsContainer = connect(
	state => ({
		classRooms: state.classRooms,
		players: state.players
	}),
	dispatch => ({
		bridge: data => dispatch(data),
		initClassRooms: accountId => dispatch(classRoomsAction(accountId, 1)),
		classRoomsPageChange: (accountId, page) => dispatch(classRoomsAction(accountId, page)),
		initPlayers: (accountId, id) => dispatch(playersAction(accountId, id))
	})
)(ClassRoomsContainer);

export default ClassRoomsContainer;



// WEBPACK FOOTER //
// ./src/components/containers/ClassRoomsContainer.js